import React from "react";
import { Star } from "lucide-react";

export const SeloDestaque = ({ show }) => {
  if (!show) return null;
  return (
    <span data-testid="selo-destaque" title="Média 4,8+ nas avaliações dos clientes"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide bg-[#FFF7E0] text-[#B45309] border border-[#F5C518]">
      <Star size={10} className="fill-[#F5C518] text-[#F5C518]" /> Destaque 4,8+
    </span>
  );
};
